// Helpers for the device type request flow.
//
// A device is identified by a stable, random "install id" that we persist in
// localStorage the first time we need it. Together with the browser's
// user-agent this lets the backend derive a device signature and re-identify
// the same browser profile when a temporary request token is exchanged.

const INSTALL_ID_KEY = 'deviceInstallId';
const REQUEST_DEVICE_TOKEN_KEY = 'requestDeviceToken';

function generateId() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (_e) {
    // fall through to manual generation
  }
  // RFC4122-ish fallback
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Returns a stable install id for this browser profile, creating it on demand.
export function getDeviceInstallId() {
  try {
    let id = localStorage.getItem(INSTALL_ID_KEY);
    if (!id) {
      id = generateId();
      localStorage.setItem(INSTALL_ID_KEY, id);
    }
    return id;
  } catch (_e) {
    // localStorage unavailable (private mode); fall back to an ephemeral id
    return generateId();
  }
}

// Collects the descriptors the backend needs to build the device signature.
export function getDeviceDescriptor() {
  const nav = typeof navigator !== 'undefined' ? navigator : {};
  return {
    installId: getDeviceInstallId(),
    userAgent: nav.userAgent || '',
    platform: nav.platform || '',
  };
}

export const requestDeviceTokenStorageKey = REQUEST_DEVICE_TOKEN_KEY;

export const deviceTypeLabels = {
  company: 'Firmengerät',
  counter: 'Kassensystem',
  private: 'Privates Gerät',
};
